// Possibly will be added on the BE
enum UserRole {
  Admin = 'BOAdmin',
  User = 'BOUser',
  RecruiterCompany = 'BOURecComp',
  CorporateTA = 'BOUCorpTA',
  TeammateAdmin = 'BOTeammateAdmin',
  TeammateRecruiter = 'BOTeammateRecruiter',
  TeammateSubAdmin = 'BOTeammateSubAdmin',
  Teammates = 'Teammates',
  Users = 'Users',
  All = 'All',
}

export { UserRole };
